import buildRoute from './buildRoute'

export const getDealers = async (active: boolean) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'dealers',
            data: { active },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        return console.error(err)
    }
}

export const addDealer = async (formData: any) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'dealer',
            data: formData,
        })
        if (res.data) {
            return res
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}

export const archiveDealers = async (dealer: any) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'archive-dealer',
            data: dealer,
        })
        if (res.data) {
            return res
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}

export const deleteDealers = async (selection: SelectionType) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'dealer-deletion',
            data: selection,
        })
        if (res.data) {
            return res
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}

interface SelectionType {
    dealers: []
    activate: boolean
}

export const activateDealers = async (selection: SelectionType) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'dealer-activations',
            data: selection,
        })
        if (res.data) {
            return res
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}

export const getDealerProfile = async (active: boolean) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'dealer-profile',
            data: { active },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        return console.error(err)
    }
}

interface GetDealerQueryProps {
    active: boolean
    limit?: number
    search?: any
    doNotSendPreliminarySuggestions?: boolean
}
export const getDealerQuery = async ({
    active,
    search = '',
    limit = 20,
    doNotSendPreliminarySuggestions,
}: GetDealerQueryProps) => {
    try {
        const res: any = await buildRoute({
            type: 'post',
            route: 'dealer-query',
            data: { active, limit, search, doNotSendPreliminarySuggestions },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        console.error(err)
        throw err
    }
}

interface GetDealerProps {
    active: boolean
    page?: number
    limit?: number
    filter?: any
}

export const getDealersWithLimiter = async ({
    active,
    page = 1,
    limit = 50,
    filter,
}: GetDealerProps) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'dealers-With-Limiter',
            data: { active, page, limit, filter },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        return console.error(err)
    }
}

interface GetDealerIdProps {
    dealerIds: any
}
export const getDealerById = async ({ dealerIds }: GetDealerIdProps) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'dealersById',
            data: { dealerIds },
        })
        if (res.data) {
            return res
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}

const dealerRoutes = {
    getDealers,
    addDealer,
    archiveDealers,
    deleteDealers,
    activateDealers,
    getDealerQuery,
    getDealersWithLimiter,
    getDealerById,
    getDealerProfile,
}

export default dealerRoutes
